/***
 * 玩法相关赔率提取
 */
import objectPath from 'object-path';

// 连尾的固定号码
export const lianMaWeishu_value = {
  '0尾': '10,20,30,40',
  '1尾': '01,11,21,31,41',
  '2尾': '02,12,22,32,42',
  '3尾': '03,13,23,33,43',
  '4尾': '04,14,24,34,44',
  '5尾': '05,15,25,35,45',
  '6尾': '06,16,26,36,46',
  '7尾': '07,17,27,37,47',
  '8尾': '08,18,28,38,48',
  '9尾': '09,19,29,39,49',
};


/**
 * 合成数据
 * @param odds      数据源
 * @param isNumber  是否是获取号码
 * @returns {Array}
 */
function generateData(odds, isNumber) {
  const data = {};
  const DEFAULT_DATA = [];
  if (isNumber) {
    odds.forEach(item => {
      if (!data[item.class2]) data[item.class2] = [];
      const checkClass3 = isNaN(Number(item.class3));
      if (!checkClass3) {
        data[item.class2].push({
          ...item,
          selected: false,
          rate: item.odds
        });
      }
    });
  } else {
    odds.forEach(item => {
      if (!data[item.class2]) data[item.class2] = [];
      const checkClass3 = isNaN(Number(item.class3));
      if (checkClass3) {
        data[item.class2].push({
          ...item,
          selected: false,
          rate: item.odds
        });
      }
    });
  }

  Object.keys(data).forEach(title => {
    if (data[title] instanceof Array) data[title] = data[title].map(item => ({
      ...item,
      label: item.class3
    }));
    const newTitle = objectPath.get(data[title], '0.class2') || '';
    const item = {
      title: newTitle,
      list: data[title]
    };
    if (data[title].length > 0) {
      DEFAULT_DATA.push(item);
    }
  });
  return DEFAULT_DATA;
}

/**
 * lh 系列玩法UI展示数据优化
 * @param odds      数据源
 * @param current   当前菜单数据
 * @param shengxiaoData   生肖号码
 * @param playTypeRadio   当前胆拖等玩法的状态
 * @returns {{horizontal: Array, vertical: Array}}
 */
export const computedDataLH = (odds, current, shengxiaoData, playTypeRadio) => {

  let list = {
    vertical: [],
    horizontal: []
  };

  if (!current) return list;
  list.vertical = generateData(odds, true);
  list.horizontal = generateData(odds);

  // 特殊的玩法，需要对数据做特别的处理
  const {sub_category_id} = current;
  // 总肖
  if (sub_category_id === 10) {
    const horizontalList = objectPath.get(list, 'horizontal.0.list');
    if (horizontalList) {
      const DEFAULT_DATA = list.horizontal[0].list;
      list.horizontal = [{
        title: list.horizontal[0].title,
        list: DEFAULT_DATA.concat(list.horizontal[1].list)
      }];
    }
  }
  // 特码
  if (sub_category_id === 1) {
    const horizontalList = objectPath.get(list, 'horizontal.0.list');
    if (horizontalList) {
      const horizontalItem = generateData(odds);
      list.horizontal = [horizontalItem[0], horizontalItem[0]];
    }
  }
  // 正码
  if (sub_category_id === 2) {
    const horizontalList = objectPath.get(list, 'horizontal.0.list');
    if (horizontalList) {
      const DEFAULT_DATA = list.horizontal[0].list;
      list.horizontal = [{
        title: list.horizontal[0].title,
        list: DEFAULT_DATA.concat(list.horizontal[1].list)
      }];
    }
  }
  // 特肖首位
  if (sub_category_id === 4) {
    const horizontalList = objectPath.get(list, 'horizontal');
    if (horizontalList && horizontalList.length > 0) {
      list.horizontal = [horizontalList[0], horizontalList[1]];
      list.vertical = [horizontalList[2]];
    }
  }
  // 一肖尾数 合肖
  if (sub_category_id === 5 || sub_category_id === 11) {
    const horizontalList = objectPath.get(list, 'horizontal');
    if (horizontalList && (horizontalList.length > 0)) {
      list.horizontal = [];
      list.vertical = horizontalList;
    }
  }
  // 连肖  连尾
  if (sub_category_id === 6 || sub_category_id === 7) {
    const horizontalList = objectPath.get(list, 'horizontal');
    if (horizontalList && (horizontalList.length > 0)) {
      list.horizontal = [];
      list.vertical = horizontalList;
    }
  }
  // 连码
  if (sub_category_id === 8) {
    const verticalList = objectPath.get(list, 'vertical');
    if (verticalList && (verticalList.length > 0)) {
      list.horizontal = [];

      let new_data_shengxiao = [];
      let new_data_weishu = [];
      let new_data_list = [];

      // 根据生肖分成生肖组
      const generateShengxiaoDataGroup = (dataSource, list) => {
        let DEFAULT_SHENGXIAO_NUMBER_ITEMS = {};
        dataSource.forEach((shengtxiaoItem) => {
          const DEFAULT_sx_item = [];
          shengtxiaoItem.m_number.split(',').forEach(sxItem => {
            const DEFAULT_ITEM = list.find(listItem => {
              const numberClass3 = listItem.class3 < 10 ? `0${listItem.class3}` : listItem.class3;
              return numberClass3 == sxItem;
            });
            DEFAULT_sx_item.push(DEFAULT_ITEM);
          });
          DEFAULT_SHENGXIAO_NUMBER_ITEMS[shengtxiaoItem.sx] = DEFAULT_sx_item;
        });
        return DEFAULT_SHENGXIAO_NUMBER_ITEMS;
      };

      // 寻找生肖组中，最小赔率的那个
      const findShengxiaoMinRate = (dataSource) => {
        return dataSource.reduce((acc, item) => {
          const newAcc = typeof acc === 'number' ? acc : acc.rate;
          return Math.min(newAcc, item.rate);
        });
      };

      /**
       * 生成这一组生肖，最小的号码赔率
       * @param numbers       生肖号码组
       * @param dataSource    所有的赔率组
       */
      const generateOddsArr = (numbers, dataSource) => {
        // 存储当前生肖 所有号码的赔率
        const oddsArr = {};
        numbers.split(',').forEach(number => {
          let DEFAULT_CLASS3 = '';
          if (dataSource.some(dataListItem => {
            const numberClass3 = dataListItem.class3 < 10 ? `0${dataListItem.class3}` : dataListItem.class3;
            if (numberClass3 == number) {
              DEFAULT_CLASS3 = dataListItem.rate;
              return true;
            }
            return false;
          })) {
            oddsArr[number] = DEFAULT_CLASS3;
          }
        });
        return oddsArr;
      };

      // 生成生肖的结构
      const generateShengxiaoData = (dataSource, dataList) => {
        const DEFAULT_FIRST = objectPath.get(dataList, 0);
        const newShengxiaoDataGroup = generateShengxiaoDataGroup(dataSource, dataList);
        const DEFAULT_DATA = [];
        dataSource.forEach((dataItem, index) => {
          // 存储当前生肖 所有号码的赔率
          const oddsArr = generateOddsArr(dataItem.m_number, dataList);
          const minRate = findShengxiaoMinRate(newShengxiaoDataGroup[dataItem.sx], 0);

          DEFAULT_DATA.push({
            ...DEFAULT_FIRST,
            id: `1${DEFAULT_FIRST.id + index}`,
            odds_tpl_id: Number(`1${DEFAULT_FIRST.id + index}`),
            numberGroup: dataItem.m_number,
            class3: dataItem.sx,
            label: dataItem.sx,
            rate: minRate,
            odds: minRate,
            oddsArr
          })
        });
        return DEFAULT_DATA;
      };
      // 生成尾数所需要的结构
      const generateWeiShuData = (dataList) => {
        const DEFAULT_FIRST = objectPath.get(dataList, 0);
        // 组建符合生肖的结构
        const lianmaWeishuArr = [];
        const DEFAULT_data = [];
        Object.keys(lianMaWeishu_value).forEach((item) => {
          lianmaWeishuArr.push({
            m_number: lianMaWeishu_value[item],
            sx: item
          });
        });
        const newShengxiaoDataGroup = generateShengxiaoDataGroup(lianmaWeishuArr, dataList);

        for (let i = 0; i < 10; i++) {
          const weishuLabel = `${i}尾`;
          const minRate = findShengxiaoMinRate(newShengxiaoDataGroup[weishuLabel], 0);
          const oddsArr = generateOddsArr(lianMaWeishu_value[weishuLabel], dataList);

          DEFAULT_data.push({
            ...DEFAULT_FIRST,
            id: `2${DEFAULT_FIRST.id + i}`,
            odds_tpl_id: Number(`2${DEFAULT_FIRST.id + i}`),
            numberGroup: lianMaWeishu_value[weishuLabel],
            class3: weishuLabel,
            label: weishuLabel,
            rate: minRate,
            odds: minRate,
            oddsArr
          })
        }
        return DEFAULT_data;
      };
      const new_list = verticalList[0].list;
      const new_title = verticalList[0].title;
      new_data_shengxiao = generateShengxiaoData(shengxiaoData, new_list);
      new_data_weishu = generateWeiShuData(new_list);
      if (playTypeRadio == 1 || playTypeRadio == 2) {
        new_data_list = new_list;
      }
      if (playTypeRadio == 3) {
        new_data_list = new_data_shengxiao;
      }
      if (playTypeRadio == 4) {
        new_data_list = new_data_weishu;
      }
      if (playTypeRadio == 5) {
        new_data_list = [new_data_shengxiao, new_data_weishu];
      }
      if (playTypeRadio == 6) {
        new_data_list = [new_list,new_data_shengxiao];
      }
      list.vertical = [{
        title: new_title,
        list: new_data_list
      }];
    }
  }
  return list;
};

// 投注时，需要区分投注时选了多少个号码
export const currentTabKey = {
  1: ['一粒任中'],
  2: ['二肖连中', '二肖连不中', '二尾连中', '二尾连不中', '二全中', '二中特', '二中特X', '特串', '二肖', '二粒任中'],
  3: ['三肖连中', '三肖连不中', '三尾连中', '三尾连不中', '三全中', '三中二', '三中二X', '三肖', '三粒任中'],
  4: ['四肖连中', '四肖连不中', '四尾连中', '四尾连不中', '四不中', '四肖', '四粒任中', '四中一'],
  5: ['五肖连中', '五肖连不中', '五尾连中', '五尾连不中', '五不中', '五肖', '五粒任中', '五中一'],
  6: ['六不中', '六肖', '六中一'],
  7: ['七不中', '七中一'],
  8: ['八不中', '八中一'],
  9: ['九不中', '九中一'],
  10: ['十不中', '十中一'],
  11: ['十一不中'],
  12: ['十二不中']
};


// 获取当前长度
export const lhCurrentTabLength = (class2) => {
  let DEFAULT_LENGTH = 0;
  Object.keys(currentTabKey).some(key => {
    if (currentTabKey[key].some(key => key === class2)) {
      DEFAULT_LENGTH = key;
    }
  });
  return DEFAULT_LENGTH;
};

/**
 * 生成数据
 * @param orders      赔率
 * @param info        当前玩法信息
 * @param radioType   是否是单注 |胆拖
 * @param selectDantuoList  当前玩法胆拖list
 * @returns {Array}
 */
export const lhComputedLm = (orders, info, radioType, selectDantuoList) => {
  const funs = (number) => list => combine(list, number);
  const key = info.played_name.trim();
  const length = lhCurrentTabLength(key);
  const class3List = [];
  orders.map((item, index) => {
    class3List.push(item.class3)
  });
  // 正常玩法
  let res = length ? funs(length)(orders.map(item => item.label)).map((item, index) => {
    const firstItemId = objectPath.get(orders, `0.id`);
    let id = firstItemId ? firstItemId + index : index + 1;
    return {
      ...info,
      class4: item.join(','),
      class3: class3List.join(','),
      rate: getMinRate(item, orders),
      odds: getMinRate(item, orders),
      id
    };
  }) : [];
  // 胆拖
  if (radioType == 2) {
    const newLength = length - 1 || 0;
    const dantuoList = [];
    const dantuoKey = [];
    let otherDantuoList = [];
    // 根据选中的胆拖数据，生成胆拖前缀数组
    Object.keys(selectDantuoList).forEach(dantuoItem => {
      dantuoKey.push(dantuoItem);
      dantuoList.push(selectDantuoList[dantuoItem]);
    });
    // 除了胆拖数据外，其他数据的数组，这个需要根据class3 生肖过滤
    otherDantuoList = orders.filter(orderItem => {
      return !dantuoKey.some(key => orderItem.class3 === key);
    });
    const class4 = [];
    const tuoma = [];
    dantuoList.forEach(dantuoItem => class4.push(dantuoItem.class3));
    otherDantuoList.forEach(otherDantuoItem => tuoma.push(otherDantuoItem.class3));
    const newRes = [];
    otherDantuoList.forEach((otherItem, index) => {
      const generateClass4 = `${class4.join(',')},${otherItem.class3}`;
      const generateClass4Arr = generateClass4.split(',');
      newRes.push({
        ...otherItem,
        class4: generateClass4,
        class3: `${class4.join(',')}拖${tuoma.join(',')}`,
        rate: getMinRate(generateClass4Arr, orders),
        odds: getMinRate(generateClass4Arr, orders),
        id: 300 + index
      })
    });
    res = newRes;
  }
  // 生肖、尾数
  if (radioType == 3 || radioType == 4 || radioType == 5) {
    const newOrders = [];
    orders.forEach(order => {
      order.numberGroup.split(',').forEach(numberItem => {
        newOrders.push({
          ...order,
          class3: numberItem
        })
      })
    });

    res = funs(2)(newOrders.map(item => item.class3)).map((item, index) => {
      const firstItemId = objectPath.get(newOrders, `0.id`);
      let id = firstItemId ? firstItemId + index : index + 3;
      return {
        ...info,
        class4: item.join(','),
        class3: `${class3List[0]}串${class3List[1]}`,
        value: newOrders.length ? newOrders[0].value : NaN,
        rate: getMinRate(item, newOrders),
        odds: getMinRate(item, newOrders),
        id
      };

    });
  }
  // 号码对碰
  if (radioType == 6) {
    let duipengList1 = [];
    let duipengList2 = [];
    const class4 = [];
    const tuoma = [];
    orders.forEach((item, index) => {
      if(item._haomaduipeng=='section1'){
        duipengList1.push(item);
        class4.push(item.class3);
      }else if(item._haomaduipeng=='section2'){
        duipengList2.push(item);
        tuoma.push(item.class3);
      }
    });
    const newRes = [];
    duipengList1.forEach((otherItem, index) => {
      duipengList2.forEach((otherItem1, index1) => {
        if(otherItem.class3!=otherItem1.class3){
          var generateClass4 = `${otherItem.class3},${otherItem1.class3}`;
          if(parseInt(otherItem.class3)>parseInt(otherItem1.class3))
          generateClass4 = `${otherItem1.class3},${otherItem.class3}`;
          const generateClass4Arr = generateClass4.split(',');
          const doesExist = newRes.some(item => item.class4 === generateClass4);
          if (!doesExist) {
            newRes.push({
              ...otherItem,
              class4: generateClass4,
              class3: `${class4.join(',')}碰${tuoma.join(',')}`,
              rate: getMinRate(generateClass4Arr, orders),
              odds: getMinRate(generateClass4Arr, orders)
            })
          }
        }
      });
    });
    res = newRes;
  }
  	//-------------------------------//
	  //一个item为拆出的一组，如1,13,肖自己数、尾自己数不与自己数组合,但肖对尾如果肖自己数又属尾数就要组，例如年肖碰9尾，1,49需包括
	  //排除自己与自己的组合 arr.splice
	 var okarr = new Array();
	if(radioType == 3 || radioType == 4)//生肖对碰 尾数对碰 要排除同尾的组
	{
	 okarr=cleararr(res,radioType);
	}
	else if(radioType == 5)//混合对碰
	{
		//先识别是肖碰肖还是肖碰尾 或是尾碰尾
		var c3=res[0].class3;
		if(checktype(c3)==0)//0 肖肖 1：肖尾  2：尾尾
		{
			 okarr=cleararr(res,3);
		}
		else if(checktype(c3)==1)//肖尾对碰排除同肖与同尾，但要注意同肖的数但又在要碰的尾数中的数不排除
		{
			var zufirst=res[0].class4.split(",");
			var sxnum=zufirst[0];//生肖第一个数，用来识别这个生肖包含什么数
			var wei=c3.substr(-2,1);//要碰的尾数
			const weishuLabel = `${wei}尾`;
			var weistr=lianMaWeishu_value[weishuLabel];
			var sxarr=getsxnum(sxnum);//生肖arr
			var weiarr=weistr.split(",");//尾数arr
			//for(let i=0,len=sxarr.length;i<len;i++){
				//alert(sxarr[i]);
			//}
			var okarr = new Array();

			 for(let i=0,len=res.length;i<len;i++){
				var c4=res[i].class4;
				var c4arr=c4.split(",");
				var notsamesx=sameanimal(c4arr);//两个号不同生肖
				var notsamewei=samewei(c4arr);//两个号不同尾
				var c4=res[i].class4;
				var c4arr=c4.split(",");
				var isok=sxpengwei(c4arr,sxarr,weiarr);
				if(isok)
				 {
					okarr.push(res[i]);
				 }
			 }
		}
		else if(checktype(c3)==2)
		{
			 okarr=cleararr(res,4);
		}
		else
		{
			okarr=res;
		}
	}
	else
	{
		okarr=res;
	}
  return okarr;//得到的分拆所有组
};

//过滤生肖尾数对碰
function cleararr(res,radioType)
{
	var okarr = new Array();
	 for(let i=0,len=res.length;i<len;i++){
		var c4=res[i].class4;
		var c4arr=c4.split(",");
		if(radioType==3)//生肖对碰
		 {
			var notsame=sameanimal(c4arr);
		 }
		 else if(radioType==4)//尾数对碰
		 {
			var notsame=samewei(c4arr);
		 }
		if(notsame)
		 {
			okarr.push(res[i]);
		 }
	 }
	 return okarr;
}

//通过生肖第一个号码获取这个生肖所有的号码
function getsxnum(sxnum)
{
	sxnum=parseInt(sxnum);
	var sxarr=new Array();
	for(let i=0;i<5;i++)
	{
		var tmp=sxnum+i*12;
		if(tmp<50)
		{
			sxarr.push(tmp);
		}
	}
	return sxarr;
}
//计算混合对碰有多少个尾字，用来识别具体是什么碰什么
function checktype(str)
{
	var result = str.match(/尾/g);
	var size = (result || []).length
	return size;//0 肖肖 1：肖尾  2：尾尾
}

//判断两个号码是否同一个生肖
function sameanimal(arr)
{
	var cha=arr[1]-arr[0];
	if (cha%12==0)//两个号同生肖
	{
		return false;
	}
	else
	{
		return true;
	}
}
//判断两个号码是否同尾
function samewei(arr)
{
	var cha=arr[1]-arr[0];
	if (arr[1]%10==arr[0]%10)//两个号同尾
	{
		return false;
	}
	else
	{
		return true;
	}
}
//同尾排除，同肖但又不在尾的排除
function sxpengwei(arr,sxarr,weiarr)
{
	var re=true;
	var cha=parseInt(arr[1])-parseInt(arr[0]);
	var cha=cha+48;
	if (arr[1]%10==arr[0]%10)//两个号同尾并且两个号都不在生肖中才排除
	{
			if(!in_array(arr[0],sxarr) && !in_array(arr[1],sxarr))
			{
			re=false;
			}
	}
	if (cha%12==0)//两个号同生肖  并且两个号都不在尾数中才排除
	{
		//同肖数而且两个数都不在尾数的数组中排除
		var wei0=arr[0];
		if(wei0<10)
		{
			var wei0='0'+arr[0];
		}
		var wei1=arr[1];
		if(wei1<10)
		{
			var wei1='0'+arr[1];
		}
		if(!in_array(wei0,weiarr) && !in_array(wei1,weiarr))
		{
			re=false;
		}
	}
	//
	return re;
}
function in_array(search,array){
    for(let i=0,len=array.length;i<len;i++)
	{
        if(array[i]==search){
            return true;
        }
    }
    return false;
}
//-------------------//
//去掉数组重复元素
function uniqueArray(arr){
  var hash = {};
  var result = [];
  for(let i=0,len=arr.length;i<len;i++){
    if(!hash[arr[i]]){
      result.push(arr[i]);
      hash[arr[i]]=true;
    }
  }
  return result;
}

function combine(arr, num) {
  arr = uniqueArray(arr);
  const r = [];
  (function f(t, a, n) {
    if (n == 0) {
      let PUSH_ARR = t;
      // 这里是比较号码，小的排前面，过滤掉生肖尾数、转换成号码对比
      if(Array.isArray(t) && t.length >= 2 && !isNaN(Number(t[0]))){
        PUSH_ARR = PUSH_ARR.map(x => Number(x));
        PUSH_ARR.sort(function(a,b){return a>b?1:-1});
      }
      return r.push(PUSH_ARR);
    }
    for (let i = 0, l = a.length; i <= l - n; i++) {
      f(t.concat(a[i]), a.slice(i + 1), n - 1);
    }
  })([], arr, num);
  return r;
}

// 获取当前item的最小费率
function getMinRate(checkKey, dataSource) {
  // 存储符合要求的数据item
  let default_check_arr = [];
  let playedName = '';
  // 获取当前相连的item
  checkKey.forEach(checkItem => {
    const findItem = dataSource.find(dataItem => dataItem.class3 == checkItem);
    if (findItem !== -1) {
      // 正常玩法直接取findItem odds，但是设计到生肖 尾数的玩法，当前行包含五六个数字，把当前的odd 按照{number: odd}的形式存在了 oddsArr中
      const odds = objectPath.get(findItem, `oddsArr.${checkItem}`) || findItem.odds;
      default_check_arr.push(odds);
      if (findItem.class1=="连尾"){
        playedName = "连尾";
      }
    }
  });
  // 找到最小费率
  const default_rate = default_check_arr.reduce((arr, item) => {
    if(playedName == "连尾"){
      return Math.max(arr, item);
    }
    return Math.min(arr, item);
  });
  return default_rate || 0;
}



// WEBPACK FOOTER //
// ./src/utils/lhComputed.js